<template>
  <div class="LegalPeopleInfo">
      <van-field
        readonly
        clickable
        :label="label"
        :value="value"
        :placeholder="placeholder"
        right-icon="arrow"
        @click="showLocationPlacePicker = true"
      />
      <van-popup
        v-model="showLocationPlacePicker"
        position="bottom"
        :style="{ height: '40%' }"
      >
        <van-area
          :area-list="areaList"
          @confirm="comfirmPlace"
          @cancel="showLocationPlacePicker = false"
        />
      </van-popup>
      <div class="line">
      </div>
  </div>
</template>

<script>
import service from '@/request/api';
// 导入api接口
export default {
  name: 'LocatedPlacePicker',
  props: ['label', 'placeholder', 'model', 'value'],
  data() {
    return {
      showLocationPlacePicker: false,
      areaList: {},
    };
  },
  mounted() {
    service.CommonForms.getAreaList()
      .then((res) => {
        this.areaList = res.data;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  inject: ['root'],
  methods: {
    comfirmPlace(value) {
      this.showLocationPlacePicker = false;
      let temp = '';
      value.forEach((item) => {
        if (item) {
          temp += `${item.name || ''} `;
        }
      });
      if (value.slice(-1)[0]) {
        this.root.getBorrowerAddressCode(value.slice(-1)[0].code);
      } else {
        this.root.getBorrowerAddressCode(value[0].code);
      }
      this.$emit('input', temp);
    },
  },
};
</script>
<style scoped>
.bgColor {
  background: #f8f8f9;
}
.LegalPeopleInfo{
  position: relative;
}
.LegalPeopleInfo >>> .van-cell::after{
  border-bottom: 0px;
}
.line {
  width: 92%;
  height: 1px;
  margin: 0 auto;
  background: #efeff1;
  pointer-events: none;
}
</style>
